import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, MessageBar } from 'common/components';

const ErrorModal = props => {
  const { open, handleToggle } = props;

  if (!open) return null;

  return (
    <Modal onToggle={handleToggle} theme={['narrow']} header={'Oops'}>
      <MessageBar
        message="Something went wrong on our side"
        theme={['vertical-gap']}
      />

      <small>
        <strong>
          For further assistance, please contact AGI Grow support at{' '}
          <a href="mailto:support@agigrow.com">support@agigrow.com</a>.
        </strong>
      </small>

      <section className="field__group">
        <fieldset className="field text--center">
          <Button className={'btn btn--primary'} onClick={handleToggle}>
            Ok
          </Button>
        </fieldset>
      </section>
    </Modal>
  );
};

ErrorModal.propTypes = {
  open: PropTypes.bool,
  handleToggle: PropTypes.func,
};

ErrorModal.defaultProps = {
  open: false,
  handleToggle: () => {},
};

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/common/components/ErrorModal/index.js